"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageAction = exports.Instrument = void 0;
var _generic_events = require("../../generic_events");
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @deprecated This feature has been replaced by Generic Events. Use/Import `GenericEvents` instead. This wrapper will be removed in a future release
 */
class Instrument extends _generic_events.GenericEvents {
  constructor(agentIdentifier, aggregator, auto = true) {
    super(agentIdentifier, aggregator, auto);
  }
}

/**
 * @deprecated This feature has been replaced by Generic Events. Use/Import `GenericEvents` instead. This wrapper will be removed in a future release
 */
exports.Instrument = Instrument;
const PageAction = exports.PageAction = Instrument;